import CaptainCatalogItems from 'dashboard/api/captain/catalogItems';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const STORE_NAME = 'CaptainCatalogItem';
const SET_META = `SET_${STORE_NAME.toUpperCase()}_META`;

export default createStore({
  name: STORE_NAME,
  API: CaptainCatalogItems,
  getters: {
    getLimit: state => state.meta.limit || {},
  },
  mutations: {
    // The factory's SET_META keeps only the count and the page. The ceiling comes down with
    // the same response, and it is what lets the page stop offering "add" before the request
    // fails, so it is kept here instead of being dropped.
    [SET_META](state, meta = {}) {
      const limit = meta.limit || {};

      state.meta = {
        ...state.meta,
        totalCount: Number(meta.total_count || 0),
        page: Number(meta.page || 1),
        limit: {
          totalCount: Number(limit.total_count || 0),
          consumed: Number(limit.consumed || 0),
          currentAvailable: Number(limit.current_available || 0),
        },
      };
    },
  },
  actions: mutations => ({
    reindex: async ({ commit }, id) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        return await CaptainCatalogItems.reindex(id);
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    },

    // The endpoint answers with the whole item, so the card picks up the new file without
    // refetching the page.
    uploadMedia: async ({ commit }, { id, file }) => {
      try {
        const response = await CaptainCatalogItems.uploadMedia(id, file);
        commit(mutations.UPSERT, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      }
    },

    deleteMedia: async (_context, { id, attachmentId }) => {
      try {
        return await CaptainCatalogItems.deleteMedia(id, attachmentId);
      } catch (error) {
        return throwErrorMessage(error);
      }
    },
  }),
});
